import React, { useState } from "react";
import { FaThLarge } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { VisibleError } from "../Components"; // EmailValidate
import apiClient from "../Config/apiConfig";
import { TailSpin } from "react-loader-spinner";
import { toast } from "react-toastify";

const Seller = () => {
  var {url} = useParams();
  const [loader, setLoader] = useState(false);
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });
  const [error, setError] = useState({
    nameError: false,
    emailError: false,
    phoneNumberError: false,
  });
  const { name, email, phoneNumber} = contactData;
  const {
    nameError,
    emailError,
    phoneNumberError,
  } = error;

  const handleChange = (e) => {
    setContactData((data) => {
      return {
        ...data,
        [e.target.name]: e.target.value,
      };
    });
  };
  const sellerFromSubmit = async (e) => {
    e.preventDefault();
    let check = false;
    if (name.trim() === "") {
      setError((old) => {
        return {
          ...old,
          nameError: true,
        };
      });
      check = true;
    }
    if (email.trim() === "") {
      setError((old) => {
        return {
          ...old,
          emailError: true,
        };
      });
      check = true;
    }
    if (phoneNumber.trim() === "") {
      setError((old) => {
        return {
          ...old,
          phoneNumberError: true,
        };
      });
      check = true;
    }
    if (check) {
      return;
    }
    try {
      setLoader(true);
      const allData = { name, email, phoneNumber, url };
      const res = await apiClient.post(`api/createsellerdetails`, {
        allData,
      });

      if (res.data.status === "200") {
        toast.success(res.data.success);
        setContactData({
          name: "",
          email: "",
          phoneNumber: "",
        });
      } else if (res.data.status === "405") {
        toast.warning(res.data.error);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      <div className="contact-seller">
        <div className="awesome-area">
          <FaThLarge />
          Awesome! Most liked project in this area
        </div>
        <div className="get-details mt-4">
          <p>Contact Seller</p>
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Name"
              name="name"
              value={name}
              onChange={(e) => {
                handleChange(e);
                setError((old) => {
                  return {
                    ...old,
                    nameError: false,
                  };
                });
              }}
            />
            <VisibleError show={nameError} name="Name" />
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              name="email"
              value={email}
              onChange={(e) => {
                handleChange(e);
                setError((old) => {
                  return {
                    ...old,
                    emailError: false,
                  };
                });
              }}
            />
            <VisibleError show={emailError} name="Valid Email" />
            <input
              type="number"
              className="form-control"
              placeholder="Phone Number"
              name="phoneNumber"
              value={phoneNumber}
              onChange={(e) => {
                handleChange(e);
                setError((old) => {
                  return {
                    ...old,
                    phoneNumberError: false,
                  };
                });
              }}
            />
            <VisibleError show={phoneNumberError} name="Phone No" />
          </form>
          <button disabled={loader} onClick={sellerFromSubmit}>
            {loader ? (
              <div className="d-flex justify-content-center">
                <TailSpin height="25" width="25" color="#fff" />
              </div>
            ) : (
              <>
                get contact details
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default Seller;
